<template>
  <div>
    <ValidationObserver slim ref="form" v-show="!success">
      <form ref="form-register" class="inscription-step1" @submit.prevent="onSubmit">

        <div class="col2 form-item">
          <p>
            <label for="prenom">Votre prénom*</label>
            <ValidationProvider slim name="field_prenom" rules="required" v-slot="{ classes, errors }">
              <input type="text" name="prenom" id="prenom" v-model="item.field_prenom" :class="classes"/>
              <span class="error-txt">{{ errors[0] }}</span>
            </ValidationProvider>
          </p>

          <p>
            <label for="nom">Votre Nom*</label>
            <ValidationProvider slim name="field_nom" rules="required" v-slot="{ classes, errors }">
              <input type="text" name="nom" id="nom" v-model="item.field_nom" :class="classes"/>
              <span class="error-txt">{{ errors[0] }}</span>
            </ValidationProvider>
          </p>
        </div>


        <div class="col2 form-item">
          <p>
            <label for="phone">Téléphone de l’établissement*</label>
            <ValidationProvider slim name="field_phone" rules="required" v-slot="{ classes, errors }">
              <the-mask type="text" id="phone" name="phone" :class="classes"
                        mask="## ## ## ## ##"
                        v-model="item.field_telephone"></the-mask>
              <span class="error-txt">{{ errors[0] }}</span>
            </ValidationProvider>
          </p>

          <p>
            <label for="mail">Votre e-mail*</label>
            <ValidationProvider slim name="mail" rules="required|email" v-slot="{ classes, errors }">
              <input type="text" name="mail" id="mail" v-model="item.mail" :class="classes"/>
              <span class="error-txt">{{ errors[0] }}</span>
            </ValidationProvider>
          </p>
        </div>

        <div class="form-item"
             :class="{ col2: item.field_client_arrow == 0 || item.field_profil == 'medecin' || item.field_profil == 'medecin_hospitalier', col1: item.field_client_arrow == 1 }">
          <p v-if="item.field_client_arrow == 0 || item.field_profil == 'medecin' || item.field_profil == 'medecin_hospitalier'">
            <label for="profil">Votre profil</label>
            <input type="text" name="profil" id="profil" :value="profils[item.field_profil]" readonly/>
          </p>

          <p>
            <label for="rpps">Votre N° RPPS</label>
            <input type="text" name="rpps" id="rpps" v-model="item.field_rpps" readonly/>
          </p>
        </div>


        <div class="form-item"
             :class="{ col1: item.field_client_arrow == 0 || item.field_profil == 'medecin' || item.field_profil == 'medecin_hospitalier', col2: item.field_client_arrow == 1 }">
          <template v-if="item.field_client_arrow == 1">
            <p>
              <label for="code">Code client Arrow*</label>
              <ValidationProvider slim name="field_code_client_arrow" rules="required|length:8" mode="passive"
                                  v-slot="{ classes, errors }">
                <the-mask type="text" id="code" name="code" :class="classes"
                          mask="XXXXXXXX"
                          v-model="item.field_code_client_arrow"></the-mask>
                <span class="error-txt">{{ errors[0] }}</span>
              </ValidationProvider>
            </p>
            <p>
              <label for="etablissement_readonly">Nom de l’établissement</label>
              <input type="text" name="etablissement" id="etablissement_readonly" readonly
                     v-model="item.field_nom_de_l_etablissement"/>
            </p>
          </template>

          <template v-if="item.field_client_arrow == 0 || item.field_profil == 'medecin' || item.field_profil == 'medecin_hospitalier'">
            <p>
              <label for="etablissement">Nom de l’établissement*</label>
              <ValidationProvider slim name="field_nom_de_l_etablissement" rules="required"
                                  v-slot="{ classes, errors }">
                <input type="text" name="etablissement" id="etablissement" :class="classes"
                       v-model="item.field_nom_de_l_etablissement"/>
                <span class="error-txt">{{ errors[0] }}</span>
              </ValidationProvider>
            </p>
          </template>
        </div>

        <template v-if="item.field_client_arrow == 1 && item.field_profil == 'hopital'">
          <div class="col1 form-item">
            <p>
              <label for="number_order">N° de commande Arrow de moins de 6 mois*</label>
              <ValidationProvider slim name="field_number_order" rules="required" v-slot="{ classes, errors }">
                <input type="text" name="number_order" id="number_order"
                       placeholder="CDX-XXXXXXXXXX"
                       v-model="item.field_number_order"
                       :class="classes"/>
                <span class="description big">* Votre n° de commande Arrow est disponible sur vos bons de livraison<br />ou vos factures et commence par « CD »</span>
                <span class="error-txt">{{ errors[0] }}</span>
              </ValidationProvider>

            </p>
          </div>
        </template>

        <template v-if="item.field_client_arrow == 0 || item.field_profil == 'medecin' || item.field_profil == 'medecin_hospitalier'">
          <div class="col1 form-item">
            <p>
              <label for="adresse">Adresse de établissement*</label>
              <ValidationProvider slim name="field_adresse" rules="required" v-slot="{ classes, errors }">
                <input type="text" name="adresse" id="adresse" v-model="item.field_adresse" :class="classes"/>
                <span class="error-txt">{{ errors[0] }}</span>
              </ValidationProvider>
            </p>
          </div>

          <div class="col1 form-item">
            <p>
              <label for="adresse2">Complément d’adresse de l’établissement*</label>
              <input type="text" name="adresse2" id="adresse2" v-model="item.field_complement_adresse"/>
            </p>
          </div>

          <div class="col2 form-item">
            <p>
              <label for="cp">Code postal de l’établissement*</label>
              <ValidationProvider slim name="field_code_postal" rules="required" v-slot="{ classes, errors }">
                <the-mask type="text" id="cp" name="cp" :class="classes"
                          mask="## ###"
                          v-model="item.field_code_postal"></the-mask>
                <span class="error-txt">{{ errors[0] }}</span>
              </ValidationProvider>
            </p>

            <p>
              <label for="ville">Ville de l’établissement*</label>
              <ValidationProvider slim name="field_ville" rules="required" v-slot="{ classes, errors }">
                <input type="text" name="ville" id="ville" v-model="item.field_ville" :class="classes"/>
                <span class="error-txt">{{ errors[0] }}</span>
              </ValidationProvider>
            </p>
          </div>
        </template>

        <div class="recaptcha">
          <vue-recaptcha :sitekey="recaptcha_site_key"
                         ref="googleRecaptcha"
                         @verify="markRecaptchaAsVerified"
          ></vue-recaptcha>
          <p class="error-txt" v-if="recaptchaError">{{ recaptchaError }}</p>
        </div>

        <input type="submit" value="Demander un accès"/>

      </form>
    </ValidationObserver>

    <p class="error-txt" v-if="error">{{ error }}</p>
    <p class="success-txt" v-if="success" v-html="success"></p>

  </div>
</template>

<script>
import {TheMask} from 'vue-the-mask';
import Rpps from "../../services/Rpps";
import User from "../../services/User";
import VueRecaptcha from 'vue-recaptcha';


export default {
  props: ['recaptcha_site_key'],
  components: {TheMask, VueRecaptcha},
  data() {
    return {
      error: null,
      success: null,
      profils: {
        officine: "Pharmacien en officine",
        hopital: "Pharmacien hospitalier",
        medecin: "Médecin de ville",
        medecin_hospitalier: "Médecin hospitalier"
      },
      recaptchaVerified: false,
      recaptchaError: null,
      item: {
        field_rpps: null,
        field_profil: null,
        field_client_arrow: null,
        field_prenom: null,
        field_nom: null,
        field_telephone: null,
        mail: null,
        field_code_client_arrow: null,
        field_nom_de_l_etablissement: null,
        field_adresse: null,
        field_complement_adresse: null,
        field_code_postal: null,
        field_ville: null,
        recaptcha_token: null,
        field_number_order: null,
      },
      has_etablissement: false
    }
  },
  created() {
    this.default_item = Object.assign({}, this.item);

    if (this.$route.query.rpps)
      this.item.field_rpps = this.$route.query.rpps;

    if (this.$route.query.client_arrow == 0 || this.$route.query.profil === 'medecin' || this.$route.query.profil === 'medecin_hospitalier')
      this.item.field_profil = this.$route.query.profil;

    if (this.$route.query.client_arrow)
      this.item.field_client_arrow = this.$route.query.client_arrow;

    this.getRppsData();
  },
  mounted() {

  },
  watch: {
    'item.field_code_client_arrow'(after, before) {
      if (after && after.length === 8) {
        this.checkCodeEtablissement();
      }
    }
  },
  methods: {
    markRecaptchaAsVerified(response) {
      this.recaptchaVerified = true;
      this.item.recaptcha_token = response;
    },
    onSubmit() {
      this.error = this.success = this.recaptchaError = null;
      this.$refs.form.validate().then(success => {

        if (!this.recaptchaVerified) {
          this.recaptchaError = 'Merci de cocher le Captcha.';
          success = false;
        }

        if (!success) {
          return;
        }

        this.register();
      });
    },
    register() {
      User.create(this.item).then((response) => {
        this.success = response.success;

        // Redirect
        this.success = this.success + "<br />Vous allez être rediriger vers la page d\'accueil dans quelques secondes...";
        setTimeout(() => {
          window.location.href = window.drupalSettings.path.baseUrl;
        }, 3000);

        // Wait until the models are updated in the UI
        // this.$nextTick(() => {
        //   this.item = this.default_item;
        //   this.$refs.form.reset();
        // });
      }).catch((error) => {
        this.error = error.error;

        // reset Re-captcha
        this.recaptchaVerified = false;
        this.$refs.googleRecaptcha.reset();
      }).finally((response) => {

      });
    },
    getRppsData() {
      let params = {
        profil_pharmacien: this.$route.query.profil_pharmacien
      };
      Rpps.getRppsData(this.item.field_rpps, params).then((response) => {
        this.item.field_prenom = response.prenom_d_exercice;
        this.item.field_nom = response.nom_d_exercice;
      }).catch((error) => {
        this.error = error.error;
      });
    },
    checkCodeEtablissement() {
      this.error = this.success = this.item.field_nom_de_l_etablissement = null;
      User.checkCodeEtablissement(this.item.field_code_client_arrow).then((result) => {
        this.item.field_nom_de_l_etablissement = result.customer.name;
        if (this.$route.query.client_arrow && this.$route.query.client_arrow == 1)
          this.item.field_profil = result.customer.field_profil_etablissement;

        this.has_etablissement = true;
      }).catch((error) => {
        this.error = error.error;
        this.has_etablissement = false;
      });
    },
  }
}
</script>
